// Photo gallery

$(function () {
    $('.jsGalleryOperationalCare').owlCarousel({
        loop: true,
        autoWidth: false,
        margin: 20,
        nav: true,
        dots: false,
        navText: [
            '<svg class="icon-chevron-left text-secondary mx-1 my-2"><use xlink:href="#icon-chevron-left"></use></svg>',
            '<svg class="icon-chevron-right text-secondary mx-1 my-2"><use xlink:href="#icon-chevron-right"></use></svg>'
        ],
        items: 3,
        responsive:{
          0:{
              items:1
          },
          576:{
              items:2
          },
          1000:{
              items:3
          }
        }
    });
})